import { generate } from "../../helpers/element/generate-element";
import { slideDown } from "../../helpers/utils/slide";

class CalculatorCladding {
    constructor() {
        // Discount configuration
        this.discount = {
            percentage: 25, // Discount percentage (e.g., 20 for 20% off)
            startDate: '2025-01-20 00:00:00', // Start date with time
            endDate: '2025-02-02 23:59:59' // End date with time
        };

        this.requiredInputs = [
            'length',
            'height',
            'is_ply',
            'is_sanded',
            'is_finished',
            'quantity'
        ];

        this.inputGroups = [];
        this.values = [];
        this.costValue;
        this.hasDisplayed = false;

        this.defaultVariables = {
            ply_value: 25,
            sanded_value: 10,
            finished_value: 20,
            strips_value: 28
        };

        if (this.canInit()) {
            this.getInputs();
            this.addEvents();
        }
    }

    canInit() {
        return document.querySelector('.js-calc-form[data-form=cladding]') !== null;
    }

    getInputs() {
        const inputGroups = document.querySelectorAll('.js-calc-form .af-field');

        this.inputGroups = [...inputGroups].filter((group) => {
            return this.requiredInputs.includes(group.dataset.name);
        });
    }

    addEvents() {
        const trigger = document.querySelector('.js-calculate.button');

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleClick();
        })
    }

    handleClick() {
        this.getVariableValues();
        this.getInputValues();
        this.doCalculation();
        this.displayValues();
    }

    getVariableValues() {
        let definedVariables = {};

        if (typeof values_data !== 'undefined' && values_data !== null) {
            definedVariables = values_data;
        }

        this.variables = { ...this.defaultVariables, ...definedVariables };
    }

    getInputValues() {
        this.inputGroups.forEach((inputGroup) => {
            const name = inputGroup.dataset.name;
            const input = inputGroup.querySelector('input');
            const select = inputGroup.querySelector('select');
            let value;

            if (input !== null) {
                value = input.value;
            }

            if (select !== null) {
                value = select.options[select.selectedIndex].value;;
            }

            this.values['_' + name] = value;
        });
    }

    doCalculation() {
        // Input Values
        const quantity = parseInt(this.values._quantity, 10);
        const length = parseInt(this.values._length, 10);
        const height = parseInt(this.values._height, 10);
        const isPly = this.values._is_ply === "yes";
        const isSanded = this.values._is_sanded === "yes";
        const isFinished = this.values._is_finished === "yes";

        // Set Values
        const ply = isPly ? this.variables.ply_value : 0;
        const sanded = isSanded ? this.variables.sanded_value : 0;
        const finished = isFinished ? this.variables.finished_value : 0;
        const strips = this.variables.strips_value;

        const m2 = this.round((length / 1000) * (height / 1000), 4);
        const ppm2 = ply + sanded + finished + strips;

        const price = m2 * ppm2;
        const totalPrice = price * quantity;
        
        this.costValue = totalPrice.toFixed(2);
    }

    displayValues() {
        const container = document.querySelector('.calc-form-sum__calculated');

        const submitButtons = document.querySelector('.af-submit');
        const costArea = document.querySelector('.calc-form-sum__cost');

        if (this.costValue === "NaN") {
            container.classList.add('has-error');
            const costElem = generate('span', `Please enter all values`, []);
            costArea.classList.add('is-hidden');

            setTimeout(() => {
                costArea.innerHTML = '';
                costArea.appendChild(costElem);
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                }, 300);
            }

            if (this.hasDisplayed) {
                slideUp(submitButtons, 300);
                this.hasDisplayed = false;
            }
        } else {
            container.classList.remove('has-error');
            costArea.classList.add('is-hidden');

            let priceHtml;
            if (this.isDiscountActive()) {
                const originalPrice = parseFloat(this.costValue);
                const discountedPrice = this.round(originalPrice * (1 - this.discount.percentage / 100), 2);
                priceHtml = `
                    <div class="price-display">
                        <span class="original-price">£${this.costValue}</span>
                        <span class="discounted-price">£${discountedPrice.toFixed(2)}</span>
                    </div>
                `;
            } else {
                priceHtml = `£${this.costValue}`;
            }

            setTimeout(() => {
                costArea.innerHTML = priceHtml;
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(submitButtons, 300, 'flex');
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                    this.hasDisplayed = true;
                }, 300);
            }

        }
    }

    round(num, decimals) {
        return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
    }

    isDiscountActive() {
        const currentDate = new Date();
        const startDate = new Date(this.discount.startDate.replace(' ', 'T'));
        const endDate = new Date(this.discount.endDate.replace(' ', 'T'));
        
        return currentDate >= startDate && currentDate <= endDate;
    }
}

export const calculatorCladding = () => {
    new CalculatorCladding(); // eslint-disable-line no-new
};
